module.exports = __webpack_public_path__ + "static/img/import-start.14d213f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browser-extension/import-start.jpg
// module id = 5l1A
// module chunks = 1